import { render, staticRenderFns } from "./ToolsDashboard.vue?vue&type=template&id=41a4d3e5&"
import script from "./ToolsDashboard.vue?vue&type=script&lang=ts&"
export * from "./ToolsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports